<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "ad",
  data() {
    return {};
  },
  created() {}
};
</script>
